export default "__VITE_PUBLIC_ASSET__48938f97__"